import { Reducer } from 'redux';
import { KnownAction, ToggleAudioConfigAction, SetPreviousLocationConfigAction, ResetConfigAction } from 'src/redux/ConfigActions';
import ConfigUtil from "src/utils/ConfigUtil";

/**
 * This is both the UserState and the default for the given state
 */
export class ConfigState {
    public audioEnabled: boolean;
    public previousLocation: string;

    constructor() {
        this.audioEnabled = true;
        this.previousLocation = null;
    }
}

export const ConfigReducer: Reducer<ConfigState> = (state: ConfigState = new ConfigState(), action: KnownAction) => {
    switch (action.type) {
        case "TOGGLE_AUDIO_CONFIG":
            let toggleAudioAction: ToggleAudioConfigAction = action;
            // Update local storage because redux hates pure TS
            ConfigUtil.AudioEnabled = toggleAudioAction.data;
            return {
                ...state,
                audioEnabled: toggleAudioAction.data
            };
        case "SET_PREVIOUS_LOCATION_CONFIG":
            let setPreviousLocationAction: SetPreviousLocationConfigAction = action;
            return {
                ...state,
                previousLocation: setPreviousLocationAction.data
            };
        case "RESET_CONFIG": {
            let resetConfigAction: ResetConfigAction = action;
            return new ConfigState();
        }
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            // JB - Clarification: The following line is fucking magic
            const exhaustiveCheck: never = action;
    }

    // For unrecognized actions (or in cases where actions have no effect), must return the existing state
    // (or default initial state if none was supplied)
    return state;
};



// WEBPACK FOOTER //
// ./src/redux/ConfigReducer.ts